module.exports = __webpack_public_path__ + "img/loading.6c2969a7.png";